
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pt",
      function () {
        return require("private-next-pages/pt/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pt"])
      });
    }
  